module.exports = __webpack_public_path__ + "static/media/beaconHome.c0f7889b.jpg";